import * as React from "react"

const ChartIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 15.166H1.33331C1.05998 15.166 0.833313 14.9393 0.833313 14.666C0.833313 14.3927 1.05998 14.166 1.33331 14.166H14.6666C14.94 14.166 15.1666 14.3927 15.1666 14.666C15.1666 14.9393 14.94 15.166 14.6666 15.166Z"
        fill="CurrentColor"
        // fill="#7B7C7F"
      />
      <path
        d="M9.5 15.1673H6.5C6.22667 15.1673 6 14.9407 6 14.6673V2.66732C6 1.52065 6.63333 0.833984 7.7 0.833984H8.3C9.36667 0.833984 10 1.52065 10 2.66732V14.6673C10 14.9407 9.77333 15.1673 9.5 15.1673ZM7 14.1673H9V2.66732C9 1.90065 8.64 1.83398 8.3 1.83398H7.7C7.36 1.83398 7 1.90065 7 2.66732V14.1673V14.1673Z"
        fill="CurrentColor"
        // fill="#7B7C7F"
      />
      <path
        d="M4.66667 15.1673H2C1.72667 15.1673 1.5 14.9407 1.5 14.6673V6.66732C1.5 5.52065 2.08667 4.83398 3.06667 4.83398H3.6C4.58 4.83398 5.16667 5.52065 5.16667 6.66732V14.6673C5.16667 14.9407 4.94 15.1673 4.66667 15.1673ZM2.5 14.1673H4.16667V6.66732C4.16667 5.83398 3.8 5.83398 3.6 5.83398H3.06667C2.86667 5.83398 2.5 5.83398 2.5 6.66732V14.1673V14.1673Z"
        fill="CurrentColor"
        // fill="#7B7C7F"
      />
      <path
        d="M14 15.166H11.3333C11.06 15.166 10.8333 14.9393 10.8333 14.666V9.99935C10.8333 8.85268 11.42 8.16602 12.4 8.16602H12.9333C13.9133 8.16602 14.5 8.85268 14.5 9.99935V14.666C14.5 14.9393 14.2733 15.166 14 15.166ZM11.8333 14.166H13.5V9.99935C13.5 9.16602 13.1333 9.16602 12.9333 9.16602H12.4C12.2 9.16602 11.8333 9.16602 11.8333 9.99935V14.166V14.166Z"
        fill="CurrentColor"
        // fill="#7B7C7F"
      />
    </svg>
  );
};

export { ChartIcon };
export default ChartIcon;
